import React, { useState } from 'react';
import styled from 'styled-components';
import { mediaBreakpointDown } from '../../utils/styling';
import MenuSvg from '../../images/menu.inline.svg';
import Link from '../Link';
import { navigate } from "gatsby"
import RefundLogoSvg from "../../images/logo_word_refund.svg";



const HeaderContainer = styled.header`
	${mediaBreakpointDown('md')} {
		background-color: #f0f5f8;
		background: rgba(240, 245, 248, 0.8);
	}
`;
const HeaderContent = styled.div`
	width:100%;
	padding: 30px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	position: relative;
	max-width: 1500px;
	margin: 0 auto;
	@media (max-width: 1500px) {
		justify-content: space-between;
	}
`;
const Menu = styled.img``;
const Logo = styled.div`
	> a {
		color: #232e69;
		font-size: 25px;
		font-weight: 700;
	}

	${mediaBreakpointDown('md')} {
		min-width: 300px;
		min-height: 41px;
		min-width: > a {
			min-height: 40px;
		}
	}

	${mediaBreakpointDown('xs')} {
		left: 20px;
	}
`;
const NavigationList = styled.ul`
	display: flex;
	margin: 0;
	padding: 0;
	@media (max-width: 1400px) {
		margin: 0 0 0 180px;
	}
	@media (max-width: 1150px) {
		margin: 0 0 0 140px !important;
	}
	${mediaBreakpointDown('lg')} {
		margin: 0 0 0 180px;
	}
	${mediaBreakpointDown('md')} {
		display: none;
	
`;
const NavigationItem = styled.li`
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;

	list-style: none;
	margin-right: 20px;
	:last-child {
		margin-right: 0;
	}
	> a {
		color: #fff;
		font-size: 13px;
		text-transform: uppercase;
		font-weight: 700;
		padding: 0;
		display: block;
		transition: all 0.3s ease-in-out 0s;
		text-decoration: none;
	}
	@media (max-width: 1200px) {
		line-height: 14px;
		margin-right: 8px;
	}
`;
const MenuIcon = styled.button`
	position: absolute;
	right: 30px;
	display: none;
	padding: 0;
	background: transparent;
	align-items: center;
	justify-content: center;

	${mediaBreakpointDown('md')} {
		display: flex;
	}
	${mediaBreakpointDown('xs')} {
		right: 20px;
	}
`;
const MenuListContent = styled.div`
	display: ${(props) => (props.visible ? 'flex' : 'none')};
	padding: 0 0 20px 0;
	display: flex;
	flex-direction: column;
	justify-content: start;
`;
const MenuList = styled.div`
	max-height: 0;
	overflow: hidden;
	background-color: transparent;

	transition: max-height 1s ease-in-out;
	padding: 0 20px;

	${(props) =>
		props.visible &&
		`
		transition: max-height 1s ease-in-out;
		max-height: 575px;
	`}
`;
const MenuItem = styled.div`
	border-bottom: 1px solid #ced8e1;

	:last-child {
		border-bottom: none;
	}
	> a {
		color: rgba(50, 58, 86, 0.8);
		font-size: 13px;
		text-transform: uppercase;
		font-weight: 600;
		padding: 13px 0;
		display: block;
		transition: all 0.3s ease-in-out 0s;
	}
`;

const TopFeaturesMenuItem = styled.div`
	border-bottom: 1px solid #ced8e1;

	:last-child {
		border-bottom: none;
	}
	> a {
		color: #e01efe;
		font-size: 13px;
		text-transform: uppercase;
		font-weight: 600;
		padding: 13px 0;
		display: block;
		transition: all 0.3s ease-in-out 0s;
		opacity: 0.6;
	}
`;

const TopFeaturesNavigationItem = styled.li`
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	list-style: none;
	margin-right: 20px;
	:last-child {
		margin-right: 0;
	}
	> a {
		color: #e01efee8;
		font-size: 13px;
		text-transform: uppercase;
		font-weight: 700;
		padding: 0;
		display: block;
		transition: all 0.3s ease-in-out 0s;
	}
	@media (max-width: 1200px) {
		line-height: 14px;
		margin-right: 8px;
	}
`;

const SignInLink = styled.button`
	background-color: transparent;
	background-repeat: no-repeat;
	border: none;
	cursor: pointer;
	overflow: hidden;
	outline: none;
	font-weight: inherit;
	color: rgba(50, 58, 86, 0.8);
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 0;
	display: block;
	transition: all 0.3s ease-in-out 0s;
`;

const SignUpLinkMobile = styled.button`
	background-color: transparent;
	background-repeat: no-repeat;
	border: none;
	cursor: pointer;
	overflow: hidden;
	outline: none;
	font-weight: inherit;
	color: rgba(50, 58, 86, 0.8);
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 600;
	padding: 13px 0;
	display: block;
	transition: all 0.3s ease-in-out 0s;
	text-align: left;
`;

const RefundLogo = styled.img`
	height: 70px;
`;




function Header({ dnpUrl }) {
	const [visible, setVisible] = useState(false);

	const HEADERS = [
		{
			label: 'HOME',
			url: 'https://arefund.com/',
		},
		{
			label: "Dating Apps",
			url: "/dating/"
		},
		{
			label: "Gaming",
			url: "/gaming/"
		},
		{
			label: "Online Services",
			url: "/online-service/"
		},
		{
			label: "Streaming",
			url: "/tech/"
		},
		{
			label: "Travel",
			url: "/travel/"
		},
	];

	return (
		<HeaderContainer>
			<HeaderContent>
				<Logo>
					<Link to="https://arefund.com/"><RefundLogo src={RefundLogoSvg} /></Link>
				</Logo>
				<NavigationList>
					{HEADERS.map((item) => {

						return <NavigationItem
							key={item.url}
						>
							<Link noPrefetch to={item.url}>
								{item.label}
							</Link>
						</NavigationItem>

					})}

					{/* <SignInLink
						onClick={handleLoginRedirect}
					>SIGN UP/SIGN IN</SignInLink> */}
				</NavigationList>
				<MenuIcon aria-label="Menu Options" onClick={() => setVisible(!visible)}>
					<Menu src={MenuSvg} />
				</MenuIcon>
			</HeaderContent>
			<MenuList visible={visible}>
				<MenuListContent visible={visible}>
					{HEADERS.map((item) => {
						return <MenuItem
							key={item.url}
						>
							<Link noPrefetch to={item.url}>
								{item.label}
							</Link>
						</MenuItem>
						// );
					})}

					{/* <SignUpLinkMobile onClick={handleLoginRedirect}>SIGN UP/SIGN IN</SignUpLinkMobile> */}
				</MenuListContent>
			</MenuList>
		</HeaderContainer>
	);
}

export default React.memo(Header);
